import { getCDNAssets } from '@/utils';

import styles from './styles/pending.module.less';

const Pending = () => {
  return (
    <div className={styles.container}>
      <img src={getCDNAssets('login_logo.png')} className={styles.img} />
    </div>
  );
};

export default Pending;
